import { useTheme } from 'styled-components';

import type { NavbarTheme } from './Navbar.theme';

export function useNavbarTheme(): NavbarTheme {
  return useTheme() as NavbarTheme;
}
